import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  const { t } = useLanguage();

  const categories = [
    { value: 'all', label: t('allProfessionals'), icon: 'Users' },
    { value: 'lawyer', label: t('lawyers'), icon: 'Scale' },
    { value: 'photographer', label: t('photographers'), icon: 'Camera' },
    { value: 'stylist', label: t('stylists'), icon: 'Palette' },
  ];

  return (
    <div className="w-full overflow-x-auto pb-1" style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      <div className="flex gap-2" style={{ minWidth: 'max-content' }}>
        {categories?.map((cat) => {
          const isActive = activeCategory === cat?.value;
          return (
            <button
              key={cat?.value}
              onClick={() => onCategoryChange(cat?.value)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap"
              style={{
                background: isActive ? 'linear-gradient(135deg, #00D4FF, #0099CC)' : 'rgba(255,255,255,0.05)',
                color: isActive ? '#000' : '#6B9EC4',
                border: isActive ? 'none' : '1px solid rgba(0,212,255,0.15)',
                boxShadow: isActive ? '0 0 20px rgba(0,212,255,0.3)' : 'none',
              }}
            >
              <Icon name={cat?.icon} size={16} />
              {cat?.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilter;
